<template>
  <div class="filters">
    <h3>Vælg {{$store.getters.currentCategory.Name}}</h3>
    <div class="categories">
      <button :class="{'selected' : selectedMainCategories.length == 0}" @click="clearFilter()">All</button>
      <button
        v-for="category in $store.getters.currentCategory.categories"
        :key="category"
        :class="{'selected' : selectedMainCategories.indexOf(category) != -1}"
        @click="setMainFilter(category)"
      >{{category}}</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setMainFilter(categoryName) {
      this.$store.dispatch("setSelectedMainCategory", categoryName);
    },
    clearFilter() {
      this.$store.dispatch("clearSelectedCategories");
    }
  },
  computed: {
    selectedMainCategories() {
      return this.$store.getters.selectedMainCategories;
    }
  }
};
</script>
<style lang="scss">
</style>